// extracted by mini-css-extract-plugin
export var md = "_2w-4";
export var semantic = "_2w-5";
export var sm = "_2w-3";
export var text = "_2w-6";
export var toggleInput = "_2w-0";
export var toggleSwitch = "_2w-1";
export var xs = "_2w-2";